module.exports = "/work-site/img/enter1.1b124d63.png";